<div *ngIf="loaded == 1" class="cw">

    <div class="mgt40">
        <h6 *ngIf="id === null" class="ft500">Agregar instructor</h6>
        <h6 *ngIf="id" class="ft500">Editar instructor</h6>
        <h6 class="h6Title">General</h6>
        <hr>
    </div>


    <!-- FORMULARIO PARA AGREGAR / EDITAR DOCUMENTO DE LA COLECCIÓN -->
    <div>
        <label>Nombre del Instructor</label>
        <input type="text" [(ngModel)]="instructor.nombre" [ngModelOptions]="{standalone: true}" class="fw">
    </div>
    <div>
        <label>Correo eléctronico del Instructor</label>
        <input type="text" [(ngModel)]="instructor.email" [ngModelOptions]="{standalone: true}" class="fw">
    </div>
    <div>
        <label>Resumen</label>
        <input type="text" [(ngModel)]="instructor.resumen" [ngModelOptions]="{standalone: true}" class="fw">
    </div>
    <div>
        <label>Descripción</label>
        <textarea name="mensaje" class="fw" maxlength="1000" [(ngModel)]="instructor.descripcion"
            [ngModelOptions]="{standalone: true}">
                            </textarea>
    </div>
    <div>
        <label>Porcentaje Instructor</label>
        <input type="number" [(ngModel)]="instructor.porcentaje" [ngModelOptions]="{standalone: true}" class="fw">
    </div>
    <div>
        <label>Enlace Linkedin</label>
        <input type="text" [(ngModel)]="instructor.enlaceLinkedin" [ngModelOptions]="{standalone: true}" class="fw">
    </div>
    <div><label> Foto de Perfil </label>
        <input type="file" class="fw" id="file" (change)="cargarFoto($event, 'foto')" name="image" autocomplete="off" />
    </div>
    <div>
        <div class="containerImg">
            <img *ngIf="instructor.foto" [src]="instructor.foto" alt="fotoInstructor" class="fw fh">
        </div>
    </div>
    <div><label> Imagen de Fondo </label>
        <input type="file" class="fw" id="file" (change)="cargarFoto($event, 'fotoFondo')" name="image"
            autocomplete="off" />
    </div>
    <div>
        <div class="imgFondoContainer">
            <img *ngIf="instructor.fotoFondo" [src]="instructor.fotoFondo" alt="fotoInstructor" class="fw fh">
        </div>
    </div>
    <div><label> Firma de instructor </label>
        <input type="file" class="fw" id="file" (change)="cargarFoto($event, 'firma')" name="image"
            autocomplete="off" />
    </div>
    <div>
        <div class="firmaContainer">
            <img *ngIf="instructor.firma" [src]="instructor.firma" alt="fotoInstructor" class="fw fh">
        </div>
    </div>
    <div>
        <label>¿Publicado?</label>
        <select [(ngModel)]="instructor.publicado" [ngModelOptions]="{standalone: true}" class="fw">
            <option [ngValue]="true">Si</option>
            <option [ngValue]="false">No</option>
        </select>
    </div>



    <hr>
    <h6 class="h6Title">Información de empresa</h6>



    <div>
        <label>Empresa</label>
        <select [(ngModel)]="instructor.empresaId" [ngModelOptions]="{standalone: true}" (change)="cambiaEmpresa()"
            class="fw">
            <option value="null" disabled selected>Seleccione la empresa</option>
            <option *ngFor="let item of empresas" [ngValue]="item.id">
                {{item.nombre}}
            </option>
        </select>
    </div>
    <div *ngIf="instructor.empresaId">
        <div>
            <label>ID empresa</label>
            <input type="text" value={{instructor.empresaId}} class="fw backGray" readonly>
        </div>
        <div>
            <label>Nombre empresa</label>
            <input type="text" value={{instructor.empresaNombre}} class="fw backGray" readonly>
        </div>
    </div>

    <div>
        <div class="containerImg" *ngIf="empresa">
            <img [src]=instructor.empresaFoto alt="imagenEmpresa" class="fw fh">
        </div>
    </div>

    <div fxLayout="row" class="mgt10 mgb30">
        <button class="darkButton mgt10" (click)="guardarInstructor()">Guardar</button>
        <button *ngIf="id" class="mgl10 grayButton mgt10 red-5" (click)="onDelete()">Eliminar</button>
    </div>

</div>
<div *ngIf="loaded == 0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>